const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)') === true
    || window.matchMedia('(prefers-reduced-motion: reduce)').matches === true;

export default prefersReducedMotion;
